<script setup>
import { ref, onBeforeUnmount, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useAuthStore } from "@/store/authStore";

const router = useRouter();
const authStore = useAuthStore();

const email = ref("");
const password = ref("");
const rememberMe = ref(false);
const errorMessage = ref("");
const showPassword = ref(false);
const body = document.getElementsByTagName("body")[0];
const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const handleLogin = async () => {
  try {
    await authStore.login(email.value, password.value);
    if (!authStore.isAdmin()) {
      errorMessage.value = "Access denied.";
      return;
    }
    router.push("/dashboard-default");
  } catch (error) {
    errorMessage.value = error.message;
  }
};
</script>
<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar isBlur="blur border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow" v-bind:darkMode="true" isBtn="bg-gradient-primary" />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Iniciar Sesión</h4>
                  <p class="mb-0">Ingresa tu correo electrónico y contraseña para acceder</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="handleLogin">
                    <div class="mb-3">
                      <argon-input id="email" type="email" placeholder="Correo Electrónico" name="email" size="lg" v-model="email" />
                    </div>

                    <div class="mb-3 position-relative">
                      <argon-input
                        id="password"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Contraseña"
                        name="password"
                        size="lg"
                        v-model="password"
                      />
                      <i
                        class="fa"
                        :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                        @click="showPassword = !showPassword"
                        style="position: absolute; top: 50%; right: 15px; transform: translateY(-50%); cursor: pointer;"
                      ></i>
                    </div>
                    <argon-switch id="rememberMe" name="remember-me" v-model="rememberMe">
                      Recuérdame
                    </argon-switch>
                    <router-link to="/forgot-password" class="text-primary text-sm">¿Olvidaste tu contraseña?</router-link>
                    <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>

                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="primary" fullWidth size="lg" type="submit">
                        Iniciar Sesión
                      </argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿No tienes una cuenta?
                    <router-link to="/signup" class="text-primary text-gradient font-weight-bold">
                      Regístrate
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
            <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{ backgroundImage: `url(${require('@/assets/img/house1.jpeg')})`, backgroundSize: 'cover' }"
              >
                <span class="mask bg-gradient-primary opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "Gestión de Alquiler y Venta de Propiedades con ARB"
                </h4>
                <p class="text-white position-relative">
                  Simplifica la administración de alquileres y ventas de inmuebles con ARB. Tu solución eficiente, segura y fácil de usar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
